<mat-form-field appearance="outline">
    <input 
        #searchAddressInput 
        matInput 
        type="text" 
        [placeholder]="placeholder" 
        [matAutocomplete]="auto"
        (keydown.enter)="$event.preventDefault()"
    />

    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectPlace($event)">
        <mat-option *ngFor="let item of predictions" [value]="item">{{item.description}}</mat-option>
    </mat-autocomplete>
</mat-form-field>

<app-state-section [state]="sectionState"></app-state-section>